exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".reference--smallText--hC1pReMU {\r\n  font-size: 14px;\r\n  color: #0072CE;\r\n  font-weight: 600;\r\n}\r\n\r\n.reference--col--2gCyI3wF{\r\n  padding-bottom: 15px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/referenceEditor/reference.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;;AAED;EACE,qBAAqB;CACtB","file":"reference.css","sourcesContent":[".smallText {\r\n  font-size: 14px;\r\n  color: #0072CE;\r\n  font-weight: 600;\r\n}\r\n\r\n.col{\r\n  padding-bottom: 15px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"smallText": "reference--smallText--hC1pReMU",
	"col": "reference--col--2gCyI3wF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/referenceEditor/reference.css
// module id = 415
// module chunks = 0